var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{staticClass:"relative",attrs:{"type":"dark","fixed":"top","data-toggle":"collapse","data-target":"#navi"}},[_c('b-navbar-brand',{staticClass:"navbar-brand mx-auto",attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.logoUrl}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }